import React, { useState, useEffect } from 'react'
import CarouselView from '../../../../components/record-carousel'
import { hall } from "../../../../service";
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
    Button,
    Empty,
    Divider,
    Space,
    Spin,
    Collapse,
    Modal,
    Tag,
    message,
    Avatar,
    List,
    Tabs,
} from 'antd';
import {
    ArrowLeftOutlined,
    PhoneOutlined,
    FileTextOutlined,
    ShoppingCartOutlined,
    CaretDownOutlined,
    CaretRightOutlined,
} from '@ant-design/icons';
import SiteNewsView from "../../../../components/site-news";
import MapView from '../../../../components/map'
import './index.scss'

const shopcart = require("../../../../assets/image/Shop-Cart.png")
    , phone = require("../../../../assets/image/phone-fill.png")
    , company = require("../../../../assets/image/company.png")
    , nongji = require("../../../../assets/image/nongji.png")


export default function DetailsView() {
    const { id } = useParams()
        , navigate = useNavigate()
        , [spinning, setSpinning] = useState(false)
        , [record, setRecord] = useState({})
        , [order, setOrder] = useState([])
        , [total, setTotal] = useState(0)
        , [openModal, setOpenModal] = useState(false)
        , [openTemp, setOpenTemp] = useState(false)
        , [temp, setTemp] = useState(null)
        , basic = useSelector(state => state.basic)
        , { serverUrl } = useSelector(state => state.siteInfo)
        , mapRef = React.useRef(null)
        , [location, setLocation] = useState([])

    useEffect(() => {
        if (id) {
            setSpinning(true)
            async function fetchData() {
                // const { data } = await hall.apiRecord.getDetails(id)
                const { data } = await hall.apiHall.getDetails(id)
                const { data: { list, total } } = await hall.apiHall.getOrder(data.userId, 2)
                setRecord(data)
                setOrder(list)
                setTotal(total)
                setSpinning(false)
            }
            fetchData()
        }
    }, [])

    useEffect(() => {
        if (mapRef.current && record.positions?.length) {
            async function fetchData() {
                if (basic.position && basic.position.length) {
                    drawMarker([{ id: record.id, content: record.name, latlng: record.positions }, { id: basic.id, content: basic.name, latlng: basic.position }])
                } else {
                    drawMarker([{ id: record.id, content: record.name, latlng: record.positions }])
                }
            }
            fetchData()
        }
    }, [mapRef, record, basic])

    const drawMarker = (data, isClear = true) => {
        mapRef.current.drawStrips({
            data: data,
            mode: 'multiple',
            type: "Marker",
            pmIgnore: true,
            isFitBounds: true,
            isClear,
        })
    }

    const templeteView = async () => {
        const { data } = await hall.apiHall.tempView()
        setTemp(data)
        setOpenTemp(true)
    }

    const onOrder = () => {
        if (basic.id) {
            // to do  
        } else {
            setOpenModal(true)
        }
    }
    const onChat = () => {
        if (basic.id) {
            // to do  
        } else {
            setOpenModal(true)
        }
    }

    return (
        <div className='record-details-container'>
            <div className='details-header'>
                <Button
                    icon={<ArrowLeftOutlined />}
                    type='text'
                    onClick={() => navigate(-1)}
                >返回</Button>
            </div>
            <Spin spinning={spinning}>
                {
                    record.id ? (
                        <div className='container-display-center'>
                            <div className='flex'>
                                <CarouselView images={[record.imageUrl]} />

                                <div className='record-info'>
                                    <div className='info-item record-title'>
                                        {record.name}
                                        <SiteNewsView createUid={record.userId} />
                                    </div>

                                    <div className='info-item price-item'>
                                        累计签单<span className='color-primary m-sm'> {total} </span>单
                                    </div>

                                    <div className='info-item'>
                                        <div>实物支付：{record.matterPay === 1 ? <span className='color-primary'>支持</span> : '不支持'}</div>
                                    </div>

                                    <div className='info-item flex' style={{ margin: '0 auto' }}>
                                        <div style={{ lineHeight: '60px' }}>主要作业内容： </div>
                                        <Collapse
                                            style={{ width: '500px' }}
                                            expandIcon={(panelProps) => {
                                                // 根据折叠面板的展开状态，选择不同的图标
                                                const icon = panelProps.isActive ?
                                                    <Tag className='info-tag' style={{ marginTop: 8 }} icon={<CaretDownOutlined />} bordered={false} color="gold">折叠</Tag>
                                                    : <Tag className='info-tag' style={{ marginTop: 8 }} icon={<CaretRightOutlined />} bordered={false} color="gold">展开</Tag>;

                                                return (
                                                    <span onClick={panelProps.onClick} style={{ marginRight: 8 }}>
                                                        {icon}
                                                    </span>
                                                )
                                            }}
                                            expandIconPosition={'end'}
                                            ghost
                                            items={[{
                                                key: '1',
                                                label: record.classifyNames.slice(0, 5).map(item =>
                                                    <Tag key={item} bordered={false} color="lime" className='info-tag'>
                                                        {item}
                                                    </Tag>
                                                ),
                                                children: record.classifyNames.slice(5,).length ? (
                                                    record.classifyNames.slice(5,).map(item =>
                                                        <Tag key={item} bordered={false} color="lime" className='info-tag'>
                                                            {item}
                                                        </Tag>
                                                    )) : (null),
                                                showArrow: !!record.classifyNames.slice(5,).length,
                                            }]} />
                                    </div>

                                    <div className='info-item flex'>
                                        <div>法人代表：{record.frdb}</div>
                                    </div>

                                    <div className='info-item'>
                                        所在地址：{record.address}
                                    </div>

                                    <div className='info-item'>
                                        联系电话： <span><PhoneOutlined /> {
                                            basic.id ? (<>{record.phone}</>) : (<>{record.phone.slice(0, 3) + '****' + record.phone.slice(7, 11)}</>)
                                        }</span>
                                        <Button
                                            type='link'
                                            icon={<FileTextOutlined />}
                                            onClick={templeteView}>
                                            合同预览
                                        </Button>
                                    </div>

                                    <div className='info-item flex'>
                                        主要设备：<List
                                            style={{ width: '480px', marginLeft: '20px' }}
                                            grid={{
                                                gutter: 16,
                                                md: 6,
                                                lg: 6,
                                            }}
                                            dataSource={record.devList}
                                            renderItem={(item, index) => (
                                                <List.Item style={{ width: '120px', marginLeft: '20px' }}>
                                                    <List.Item.Meta
                                                        avatar={<Avatar src={nongji} />}
                                                        title={<span style={{ display: 'inline-block', marginTop: '5px' }}>
                                                            {`${item.classify} ${item.num || '-'}台`}
                                                        </span>
                                                        }
                                                    />
                                                </List.Item>
                                            )}
                                        />
                                    </div>

                                    {
                                        basic.id ? <div className='info-item'>
                                            <Button
                                                type='primary'
                                                danger
                                                size='large'
                                                icon={<ShoppingCartOutlined />}
                                                style={{ height: 40, lineHeight: '20px' }}
                                                onClick={() => {
                                                    if (basic.id === record.userId) {
                                                        message.warning("无法在本集团下单！")
                                                        return
                                                    }
                                                    navigate(`/serviceshall/order/${id}`)
                                                }}
                                            >
                                                立即下单
                                            </Button>
                                        </div> : null
                                    }
                                </div>
                            </div>

                            <Divider />

                            <div className='flex'>
                                <Tabs
                                    style={{ width: '600px' }}
                                    defaultActiveKey="1"
                                    items={[
                                        {
                                            key: '1',
                                            label: '服务记录',
                                            children: <List
                                                style={{ width: '480px', marginLeft: '20px' }}
                                                dataSource={order.slice(0, 6)}
                                                renderItem={(item, index) => (
                                                    <List.Item >
                                                        <List.Item.Meta
                                                            title={<span>{item.orderCompany}</span>}
                                                            description={`${item.classifyName} - ${item.createDate}`}
                                                        />
                                                    </List.Item>
                                                )}
                                            />,
                                        },
                                    ]} />

                                <div style={{ flex: 1 }}>
                                    <MapView
                                        ref={mapRef}
                                        id='devs-map'
                                        height='500px'
                                        isLocate={true}
                                    >
                                    </MapView>
                                </div>
                            </div>
                        </div>

                    ) : (<div style={{ marginTop: '20vh', height: '50vh' }} />)
                }
            </Spin>

            <Modal
                title='提示'
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={[
                    <Button key="back" onClick={() => setOpenModal(false)}>
                        取消
                    </Button>
                ]}
            >
                <div className='m-lg' style={{ fontSize: '18px' }}>
                    该功能需要登录后才可使用，现在<span
                        style={{ color: '#44AFAD', cursor: 'pointer', margin: '0 4px' }}
                        onClick={() => navigate('/login')}
                    >去登录！</span>
                </div>
            </Modal>

            <Modal
                title='合同模板'
                width={1200}
                open={openTemp}
                onCancel={() => setOpenTemp(false)}
                footer={[
                    <Button key="back" onClick={() => setOpenTemp(false)}>
                        取消
                    </Button>
                ]}
            >
                <div dangerouslySetInnerHTML={{ __html: temp }} />
            </Modal>

        </div>
    )
}
